import { render, staticRenderFns } from "./hazardRectificationTab2.vue?vue&type=template&id=56345791&scoped=true"
import script from "./hazardRectificationTab2.vue?vue&type=script&lang=js"
export * from "./hazardRectificationTab2.vue?vue&type=script&lang=js"
import style0 from "./hazardRectificationTab2.vue?vue&type=style&index=0&id=56345791&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56345791",
  null
  
)

export default component.exports